export const sizeBackgroundImage = (images) => {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 350) {
    return images.find(img => img.name === 'large');
  } else if (screenWidth >= 154) {
    return images.find(img => img.name === 'medium');
  } else {
    return images.find(img => img.name === 'small');
  }
};